export type ProductPeriodMode = "lifecycle" | "selected";
export type ProductDateRange = { start: string; end: string };

export function productAnalysisRange(
  mode: ProductPeriodMode,
  selected: ProductDateRange,
  catalog: { min_date: string; max_date: string } | null,
): ProductDateRange {
  if (mode === "lifecycle" && catalog) {
    return { start: catalog.min_date, end: catalog.max_date };
  }
  return { ...selected };
}
